import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import {
    ActionTableCell,
    CheckboxTableRow,
    ExTable,
    SelectionFixedFooter,
    TableBody,
    TableHead,
    TableWrapper,
    useMultipleCheckForm,
} from 'components/shared/widget'
import { useFetchProductSetsApi } from 'api/product_set'
import { ProductSet, ProductSetSearchForm } from 'entities/product_set'
import { Pagination } from 'components/shared/pagination'
import { useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { productSetColumnInfoList, ProductSetTableData } from './product_set_table'
import { DisplaySetting, DisplaySettingModal, TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { useState } from 'react'
import { EditProductSetForm, NewProductSetForm } from './product_set_form'
import { Flex } from 'components/shared/flex'

type Props = {
    history: H.History
}

const ProductSetsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const query = useQuery<ProductSetSearchForm>()
    const searchForm = useForm<ProductSetSearchForm>(query)
    const api = useFetchProductSetsApi(searchForm)
    const multipleCheckForm = useMultipleCheckForm<ProductSet>()
    const productSetDisplaySetting = useDisplaySetting(productSetColumnInfoList(searchForm), 'ProductSet')
    const displaySettings: DisplaySetting[] = [productSetDisplaySetting]
    const [selectedProductSet, setSelectedProductSet] = useState<ProductSet>({})
    const [showEdit, setShowEdit] = useState<boolean>(false)

    useEffect(() => {
        api.execute()
    }, [])

    const handleClickRemoveFilter = (key: keyof ProductSetSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`product_sets?${queryParams}`)
        }
    }, [searchForm.object])

    return (
        <>
            <EditProductSetForm
                productSet={selectedProductSet}
                show={showEdit}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    api.execute()
                    setShowEdit(false)
                }}
            />
            <ContentHeader
                headerTitle="プロダクトセット"
                left={
                    <>
                        {/* <CopyTableButton /> */}

                        <NewProductSetForm
                            onComplete={() => {
                                api.execute()
                            }}
                        />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={<DisplaySettingModal displaySettings={displaySettings} />}
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper showFooter={multipleCheckForm.form.object.items.length > 0} contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <CheckboxTableRow head allCheck allItems={api.response.results} multipleCheckForm={multipleCheckForm} showEdit>
                                <ActionTableCell th width={60} />
                                <TableHeads displaySetting={productSetDisplaySetting} />
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={productSetDisplaySetting.getColumnLength() + 2}>
                            {api.response.results.map((productSet: ProductSet) => {
                                return (
                                    <CheckboxTableRow
                                        key={`productSet-${productSet.id}`}
                                        item={productSet}
                                        multipleCheckForm={multipleCheckForm}
                                    >
                                        <ActionTableCell
                                            action="edit"
                                            onClick={() => {
                                                setSelectedProductSet(productSet)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <ProductSetTableData
                                            productSet={productSet}
                                            displaySetting={productSetDisplaySetting}
                                        />
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>

            <SelectionFixedFooter
                ids={multipleCheckForm.ids()}
                onClickReset={() => multipleCheckForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="ProductSet"
            >
            </SelectionFixedFooter>
        </>
    )
}

export default withRouter(ProductSetsPage)

